// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__13cGq","title":"Images90_title__1-SqA","images":"Images90_images__GCIx2"};